import React from 'react';
import { FaClock, FaRocket, FaEye, FaIntercom, FaList, FaRadiationAlt, FaTable } from 'react-icons/fa';
import { useModal } from 'src/hooks/Modal';
import api from 'src/services/api';
import { useLoading } from 'src/hooks/LoadingHook';
import { useToast } from 'src/hooks/Toast';
interface ICreateModule {
  lineData: Record<string, any>;
}

export default function ReviewModule({
  lineData,
}: ICreateModule): JSX.Element {

  const { addModal } = useModal();
  const { addLoading, removeLoading } = useLoading();
  const { addToast } = useToast();
  const getData = async () => {

    const [edital, papers, avaliators] = await Promise.all([


      api.get(`/cientific-selection/${lineData?._id?.toString()}`),
      api.get(`/cientific-submissions`, { params: { limitItems: 10000, where: { cientific_selective_id: lineData?._id?.toString(), orientator_approval: 'Sim' } } }),
      api.get(`/cientific-avaliators`, { params: { limitItems: 10000 } })




    ])

    const avaliatorsList: Array<Record<string, any>> = edital?.data?.avaliator_categories?.length > 0 ? [] : avaliators?.data?.rows || [];
    avaliators?.data?.rows?.map(avaliator => {

      const index = edital?.data?.avaliator_categories?.findIndex(i => i?.title === avaliator?.category);
      if (index >= 0) {
        avaliatorsList.push(avaliator)
      }


    })


    return { edital: edital?.data, papers: papers?.data?.rows, avaliators: avaliatorsList }

  }

  const generateCategoryReport = (edital, avaliators, papers) => {
    const report: Array<Record<string, any>> = [];

    edital.categories.forEach(category => {
      const categoryTitle = category.title;

      category.options.forEach(area => {
        const areaTitle = area.title;

        // Avaliadores que possuem essa categoria/área
        const avaliatorsInArea = avaliators.filter(av =>
          av.categories_list.some(c =>
            c.category === categoryTitle && c.area === areaTitle
          )
        );

        // Trabalhos que pertencem a essa categoria/área
        const papersInArea = papers.filter(p =>
          p.category === categoryTitle && p.area === areaTitle
        );

        report.push({
          category: categoryTitle,
          area: areaTitle,
          avaliatorsCount: avaliatorsInArea.length,
          papersCount: papersInArea.length,
          noAvaliators: avaliatorsInArea.length === 0,
        });
      });
    });

    return report;
  };

  const showAvaliatorsPapersList = async () => {

    const search = await getData();
    const { edital, avaliators, papers } = search;

    const list = generateCategoryReport(edital, avaliators, papers);

    const content = <>
      <table className='tableRef'>
        <tbody>
          <tr><th>Alerta</th><th>Categoria</th><th>Área</th><th>Avaliadores</th><th>Trabalhos</th></tr>
          {list?.map(item => {
            return <tr>
              <th>{item?.noAvaliators ? <div style={{ background: 'red', width: '20px', height: '20px', borderRadius: '50%' }} /> : <></>}</th>
              <th>{item?.category}</th>
              <th>{item?.area}</th>
              <th>{item?.avaliatorsCount}</th>
              <th>{item?.papersCount}</th>
            </tr>

          })}

        </tbody>
      </table>

    </>

    addModal({ theme: 'whiteModal', title: 'Lista área / avaliadores', content: content });

  }


  const distributeByRoundRobin = async () => {

    const distribution = await api.get(`/get-paper-distribution/${lineData?._id?.toString()}`)

    return distribution?.data || [];
  };

  const generateHourAvailabilityReport = (edital, avaliators): Array<Record<string, any>> => {
    const report: Array<Record<string, any>> = [];

    const allSlots = edital.avaliator_hour_fields[0].options;

    allSlots.forEach(slot => {
      const avaliatorsInSlot = avaliators.filter(av =>
        av.hours.includes(slot)
      );

      report.push({
        slot,
        avaliatorsCount: avaliatorsInSlot.length,
        noAvaliators: avaliatorsInSlot.length === 0,
      });
    });

    return report;
  };

  const showAvaliatorsByHour = async () => {

    const search = await getData();
    const { edital, avaliators, papers } = search;

    const list = generateHourAvailabilityReport(edital, avaliators);

    const content = <>
      <table className='tableRef'>
        <tbody>
          <tr><th>Alerta</th><th>Horário</th><th>Avaliadores no horário</th> </tr>
          {list?.map(item => {
            return <tr>
              <th>{item?.noAvaliators ? <div style={{ background: 'red', width: '20px', height: '20px', borderRadius: '50%' }} /> : <></>}</th>
              <th>{item?.slot}</th>

              <th>{item?.avaliatorsCount}</th>

            </tr>

          })}

        </tbody>
      </table>

    </>

    addModal({ theme: 'whiteModal', title: 'Lista área / avaliadores', content: content });

  }

  const addAvaliations = async () => {

    addLoading({ title: 'Carregando', key: 'loading' })
    try {
      await api.post(`/apply-papers-avaliations/${lineData?._id}`);

      removeLoading('loading');
      addToast({ title: 'Adicionado com sucesso!', type: 'success' })
    }
    catch (err) {
      addToast({ title: 'Erro ao inserir', type: 'error' })
      removeLoading('loading');
    }

  }

  const distributeAvaliators = async () => {

    const list = await distributeByRoundRobin();

    addModal({
      theme: 'whiteModal', title: 'Lista Trabalhos / avaliadores', content: <>
        <button className='greenButton2' onClick={() => { addAvaliations() }}>Lançar distribuição de avaliações</button>
        <table className='tableRef'>
          <tbody>
            <tr><th>Alerta</th><th>Horário</th><th>Avaliador</th><th>Autor</th><th>Trabalho</th><th>Categoria</th><th>Área</th><th>Orientador</th> </tr>
            {list?.map(item => {
              return <tr>
                <td>{!item?.found ? <div style={{ background: 'red', width: '20px', height: '20px', borderRadius: '50%' }} /> : <></>}</td>
                <td>{item?.slot}</td>
                <td>{item?.avaliator?.name}</td>
                <td>{item?.paper?.author}</td>
                <td>{item?.paper?.title}</td>
                <td>{item?.paper?.category}</td>
                <td>{item?.paper?.area}</td>
                <td>{item?.paper?.orientator}</td>
              </tr>

            })}

          </tbody>
        </table>

      </>
    });

  }






  const distributeAvaliatorsCheck = async () => {
    const edital = await api.get(`/cientific-selection/${lineData?._id?.toString()}`);

    const avaliatorsCategories: Array<Record<string, any>> = [];


    edital?.data?.avaliator_categories?.map(i => {
      avaliatorsCategories.push({ category: i?.title })
    })


    const list = await distributeByRoundRobin();
    const avaliators = await api.get(`/cientific-avaliators`, { params: avaliatorsCategories?.length > 0 ? { limitItems: 10000, where: { "$or": avaliatorsCategories } } : { limitItems: 10000 } })

    const listAvaliators: Array<Record<string, any>> = [];

    avaliators.data?.rows?.map(avaliator => {

      listAvaliators.push({
        name: avaliator?.name,
        count: list?.filter(i => i?.avaliator_id === avaliator?._id?.toString())?.length
      })
    })

    listAvaliators.sort((a, b) => a?.count > b?.count ? -1 : a?.count < b?.count ? 1 : 0)

    addModal({
      theme: 'whiteModal', title: 'Validar avaliadores', content: <>

        <table className='tableRef'>
          <tbody>
            <tr><th>Alerta</th><th>Horário</th><th>Avaliador</th><th>QTD</th>  </tr>
            {listAvaliators?.map(item => {
              return <tr>
                <td>{item?.count < 1 ? <div style={{ background: 'red', width: '20px', height: '20px', borderRadius: '50%' }} /> : <></>}</td>
                <td>{item?.name}</td>
                <td>{item?.count?.toString()}</td>


              </tr>

            })}

          </tbody>
        </table>

      </>
    });

  }


  const moduleCreate = (): JSX.Element => {

    return <> <button className='lineIcon' title='Simular distribuição' onClick={() => showAvaliatorsPapersList()}  >
      <FaList /></button>

      <button className='lineIcon' title='Simular distribuição de horários' onClick={() => showAvaliatorsByHour()}  >
        <FaClock /></button>

      <button className='lineIcon' title='Simular distribuição de trabalhos' onClick={() => distributeAvaliators()}  >
        <FaTable /></button>
      <button className='lineIcon' title='Validar avaliadores por trabalho' onClick={() => distributeAvaliatorsCheck()}  >
        <FaIntercom /></button>



    </>;
  }



  return moduleCreate();
}
